export const realResultsData = [
  {
    image: { url: 'pages/reviews/realResults/before_after_1.png', alt: "Mrs Swinfen Green's real results" },
    author: 'Mrs Swinfen Green',
    text: `Used the whitening system which had great effect.`,
  },
  {
    image: { url: 'pages/reviews/realResults/before_after_2.png', alt: "Catherine's real results" },
    author: 'Catherine',
    text: `The combined results are great. My teeth look so much better and straighter.`,
  },
  {
    image: { url: 'pages/reviews/realResults/before_after_3.png', alt: "Harriet's real results" },
    author: 'Harriet',
    text: `Big improvement particularly with the whitening.`,
  },
  {
    image: { url: 'pages/reviews/realResults/before_after_4.png', alt: "Laura's real results" },
    author: 'Laura',
    text: `Can’t explain the confidence it has given me.`,
  },
];
